import React from 'react'
import Header from "../../components/header/index";
import Footer from "../../components/footer";

import InnerHeaderFare from "../../components/comment/innerHeader/innerHeaderCheckout";
import FareSummaryContent from './faresummarycontent/fareSummaryContent';

const faresummary = () => {
  return (
    <>
    <section>
      <div className="main ">
        <Header />
        <InnerHeaderFare/>
        <FareSummaryContent />
       
        <Footer />
      </div>
    </section>
  </>
  )
}

export default faresummary